import { ArrowUpRight, Check } from "lucide-react";
import { SERVICES, IMAGES } from "../../lib/constants";

const SERVICE_IMAGES = {
  "engine-parts": IMAGES.engine,
  "mro-sales": IMAGES.mro,
};

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-[#F8F9FA] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="max-w-3xl">
          <p className="nps-eyebrow nps-divider-gold mb-5">Our Services</p>
          <h2 className="font-display font-bold text-[#0B1D3A] text-3xl sm:text-4xl lg:text-5xl leading-[1.08] tracking-tight">
            Two Services.
            <br />
            One Standard of Excellence.
          </h2>
          <p className="mt-5 text-[#4B5563] text-base leading-relaxed max-w-2xl">
            We focus on what we do best — Engine Sales, Engine Piece Parts
            Trading, and Inventory Procurement.
          </p>
        </div>

        <div className="mt-14 grid lg:grid-cols-2 gap-7">
          {SERVICES.map((svc, idx) => (
            <article
              key={svc.id}
              data-testid={`service-card-${svc.id}`}
              className="group bg-white border border-[#E5E7EB] rounded-sm overflow-hidden hover:border-[#1E3A5F] transition-all duration-300"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={SERVICE_IMAGES[svc.id]}
                  alt={svc.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B1D3A]/85 via-[#0B1D3A]/30 to-transparent" />
                <div className="absolute top-5 left-5">
                  <span className="font-mono text-[11px] tracking-[0.22em] text-[#C9A961] bg-[#0B1D3A] px-3 py-1.5 uppercase font-semibold">
                    0{idx + 1} — Service
                  </span>
                </div>
                <div className="absolute bottom-5 left-5 right-5">
                  <h3 className="font-display font-bold text-white text-2xl leading-tight">
                    {svc.title}
                  </h3>
                </div>
              </div>

              <div className="p-7">
                <p className="text-[#4B5563] text-[15px] leading-relaxed">
                  {svc.blurb}
                </p>

                <ul className="mt-6 space-y-3">
                  {svc.bullets.map((b) => (
                    <li
                      key={b}
                      className="flex items-start gap-3 text-[#111827] text-[14px] leading-relaxed"
                    >
                      <Check className="w-4 h-4 text-[#C9A961] flex-shrink-0 mt-1" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href="#contact"
                  data-testid={`service-rfq-link-${svc.id}`}
                  className="mt-7 inline-flex items-center gap-2 text-[#0B1D3A] font-semibold text-sm tracking-wide border-b-2 border-[#C9A961] pb-1 hover:gap-3 transition-all"
                >
                  Request a Quote
                  <ArrowUpRight className="w-4 h-4" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
